import React from 'react';
import { FaBullhorn } from 'react-icons/fa';
import FormulaPartnerCard from './FormulaPartnerCard';

/**
 * PartnerShowcase - Sağ sidebar partner alanı
 */
const PartnerShowcase = ({ compact = false }) => {
    return (
        <div className="w-full min-w-0 bg-white dark:bg-gray-800 rounded-xl shadow-lg p-3 sm:p-4 border border-gray-200 dark:border-gray-700 transition-colors duration-300 ease-in-out">
            {/* Header */}
            <div className="flex items-center space-x-2 mb-4 pb-3 border-b border-gray-200 dark:border-gray-700 transition-colors duration-300 ease-in-out">
                <div className="p-2 bg-amber-100 dark:bg-amber-900/30 rounded-lg transition-colors duration-300 ease-in-out">
                    <FaBullhorn className="text-amber-600 dark:text-amber-400" />
                </div>
                <div>
                    <h3 className="font-bold text-gray-900 dark:text-white">Reklam</h3>
                    <p className="text-xs text-gray-500 dark:text-gray-400">Sponsorlu Alan</p>
                </div>
            </div>

            {/* Partner Showcase Banner */}
            <div className={`w-full relative ${compact ? '' : 'min-h-[300px]'}`}>
                <FormulaPartnerCard compact={compact} />
            </div>

            {/* Footer */}
            <div className="mt-4 pt-3 border-t border-gray-200 dark:border-gray-700 transition-colors duration-300 ease-in-out">
                <p className="text-xs text-center text-gray-400 dark:text-gray-500">
                    Reklam için: iletisim@dovizdefteri.com
                </p>
            </div>
        </div>
    );
};

export default PartnerShowcase;
